import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-confirm-note-delete',
    templateUrl: './confirm-note-delete.component.html',
    styleUrls: ['./confirm-note-delete.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConfirmNoteDeleteComponent {
  constructor() {}
}
